"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceApi = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
var MaintenanceApi;
(function (MaintenanceApi) {
    let MaintenanceLocation;
    (function (MaintenanceLocation) {
        MaintenanceLocation[MaintenanceLocation["futures"] = 1] = "futures";
        MaintenanceLocation[MaintenanceLocation["spot"] = 2] = "spot";
        MaintenanceLocation[MaintenanceLocation["deposit"] = 3] = "deposit";
        MaintenanceLocation[MaintenanceLocation["withdraw"] = 4] = "withdraw";
        MaintenanceLocation[MaintenanceLocation["transfer"] = 5] = "transfer";
    })(MaintenanceLocation = MaintenanceApi.MaintenanceLocation || (MaintenanceApi.MaintenanceLocation = {}));
    MaintenanceApi.requestMaintenance = () => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost + "/maintenance/list";
        return trade_utils_lib_1.Network.get({ url: url });
    };
    MaintenanceApi.useCheckMaintenance = (location, isActive = false) => {
        const [maintenance, setMaintenance] = (0, react_1.useState)(null);
        (0, react_1.useEffect)(() => {
            if (!isActive) {
                return;
            }
            const $ob = MaintenanceApi.requestMaintenance().subscribe({
                next: (result) => {
                    if (result.location_map[`${location}`]) {
                        setMaintenance(result.location_map[`${location}`]);
                    }
                    else {
                        setMaintenance(null);
                    }
                },
                error: (e) => {
                    console.log("requestMaintenance error", e);
                },
            });
            return () => {
                $ob.unsubscribe();
            };
        }, [isActive, location]);
        return (0, react_1.useMemo)(() => {
            return { maintenance, setMaintenance };
        }, [maintenance]);
    };
})(MaintenanceApi || (exports.MaintenanceApi = MaintenanceApi = {}));
